/**
 * MSS Benefits slider. Slides are stacked in one grid cell; the active one is shown,
 * the rest are inert so keyboard and screen-reader users only meet the visible slide.
 */
(() => {
  const init = (slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-mss-benefits-slide]'));

    if (slides.length < 2) {
      return;
    }

    let active = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    const show = (index) => {
      active = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        const isActive = i === active;
        slide.classList.toggle('is-active', isActive);
        slide.inert = !isActive;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    slider.querySelector('[data-mss-benefits-prev]')?.addEventListener('click', () => show(active - 1));
    slider.querySelector('[data-mss-benefits-next]')?.addEventListener('click', () => show(active + 1));

    slider.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        show(active - 1);
      } else if (event.key === 'ArrowRight') {
        show(active + 1);
      }
    });

    show(active);
  };

  const boot = () => document.querySelectorAll('[data-mss-benefits-slider]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
